var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49941 5.25525L4.4707 6.28396L8.14466 9.95791L11.8186 6.28396L10.7899 5.25525L8.14466 7.9005L5.49941 5.25525Z",
    fill: "#8A7C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49941 12.6987L4.4707 11.67L8.14466 7.99607L11.8186 11.67L10.7899 12.6987L8.14466 10.0535L5.49941 12.6987Z",
    fill: "#8A7C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14613 15.3129C4.61614 15.3129 1.81025 12.5071 1.81025 8.97706C1.81025 5.44707 4.61614 2.64118 8.14613 2.64118C9.23228 2.64118 10.3184 2.91272 11.3141 3.4558L12.2192 1.91708C10.952 1.19298 9.59433 0.830933 8.14613 0.830933C3.6205 0.830933 0 4.45143 0 8.97706C0 13.5027 3.6205 17.1232 8.14613 17.1232C12.6718 17.1232 16.2923 13.5027 16.2923 8.97706H14.482C14.482 12.5071 11.6761 15.3129 8.14613 15.3129Z",
    fill: "#8A7C8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8b7b6eb952d52ad0fe9443ec335e3d61.svg";
export { ForwardRef as ReactComponent };